import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { EMAIL_PATTERN, NO_SELECTED_CARD, STORAGE_CUSTOMER_DATA } from '../../../../core/constants';
// services
import { PaymentService } from '../../../../core/services/payment.service';
import { RouteService } from '../../../../core/services/route.service';
import { OrderApiService } from '../../../../core/services/order.api.service';
import { StorageService } from '../../../../core/services/storage.service';
import { ConvertItemsService } from 'src/app/core/services/convert-items.service';
// stores
import { CartStore } from 'src/app/core/stores/cart.store';
import { PaymentStore, StatePayment } from '../../../../core/stores/payment.store';
// models
import {
  Mode,
  NonceType,
  Order,
  OrderTab,
  PaymentSources,
  PaymentTender,
  SquareStatus,
  SquareTokenize
} from '../../../../core/models/payment-item.model';
import { Currency, Group, Restaurant, RestaurantAvailableStatus } from '../../../../core/models/restaurant.model';
import { FulfillmentType } from '../../../../core/models/order.model';
// rxjs
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { Customer } from '../../../../core/models/customer.model';
import { FormatDataService } from '../../../../core/services/format-data.service';
import { FormatStyleService } from '../../../../core/services/format-style.service';
import { RestaurantStore } from '../../../../core/stores/restaurant.store';
import { GiftCard, GiftCarFromNonce, PartialBalance } from '../../../../core/models/gift-card.model';
import { GiftCardService } from '../../../../core/services/gift-card.service';
import { StatusCode } from '../../../../core/enums/status-code.enum';
import { Platforms } from 'src/app/core/enums/util.enum';
import { GiftCardError, GiftCardStatus } from '../../../../core/enums/gift-card.enum';
import { PaymentError } from '../../../../core/enums/payment.enum';
import { Tip } from '../../../../core/enums/tip.enum';
import {SharedOrderService} from "../../../../core/services/shared-order.service";
import { MobilePayError} from 'src/app/core/models/mobile-error.model';
import { SquarePayService } from 'src/app/core/services/square-pay-service.service';
import {UrlParam} from '../../../../core/enums/group-param.enum';
// declare var cordova: any;

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentComponent implements OnInit, OnChanges, OnDestroy, AfterViewChecked {
  public isAndroid = Platforms.ANDROID;
  public isIOS = Platforms.IOS
  @Input()
  public forceTouched;
  @Input()
  public token;
  @Input()
  public restaurant: Restaurant = new Restaurant();
  @Input()
  public tabOptionSelected: boolean;
  @Input()
  public isLoading: boolean;
  @Input()
  public restaurants: Restaurant[] = [];
  @Input()
  public isSubscription: boolean;
  @Input()
  public group: Group = new Group();
  @Input('invalid')
  public set checkoutInvalid(invalid: boolean) {
    this._invalid = invalid;
    this.cdRef.markForCheck();
  }
  @Output()
  public validChange: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Output()
  public paymentItemError = new EventEmitter<string>();
  @Output()
  public onWalletForceTouched = new EventEmitter();

  public cardId: string;
  private groupOrderId: string;
  private payLocationId: string;
  private isNeedCustomerName: boolean;
  private isNeedBillingAddress: boolean;
  private isProcessingOrder: boolean;
  public isSendPayRequest: boolean;
  public isHaveCard: boolean;
  public isRemoveCard: boolean;
  public isRemovalProcess: boolean;
  public isLoaded: boolean;
  public isFormLoaded: boolean;
  public userPhoneNumber = this.routing.snapshot.queryParams.userPhoneNumber;
  public isAdditional = false;
  public isGiftBalance = false;
  public isGiftCardVerify = false;
  public squareTokenizeGift: SquareTokenize = new SquareTokenize();
  public squareTokenizeCard: SquareTokenize = new SquareTokenize();
  public giftCardBalance: string;
  public remainBalance: number;
  public isSourcePayment = false;

  // data for payment
  private showCardPaymentForm = true;
  public showGiftCardPaymentForm = false;
  private paymentForm: any = null;
  private card: any;
  private giftCard: any;
  private googlePay: any;
  private applePay: any;
  public nonceType = NonceType;
  public isGiftCardPermission: boolean;
  private merchantId: string = null;
  public isCanUseApplePay:boolean = this.squarePayService.isCanUseApplePay;
  public isCanUseGooglePay:boolean = this.squarePayService.isCanUseGooglePay;

  public mode: string;
  public doSaveCard = true;
  public doSaveGiftCard = true;
  public savedPayment = true;
  public showCheckboxWarningMessage = false;
  public lastTotal = 0;
  public givenName = '';
  public familyName = '';
  public email = '';
  public touched = false;
  public _invalid = true;
  public isCordova = false;
  private valid = false;
  private processOrderQueue = [];
  private walletFormDestroyed = false;
  private destroyed$ = new Subject<void>();
  public isSpinner = false;
  private tip = Tip;
  public sharedOrderId: string;
  private reInitWallet = false;
  private isGoogleAttached = false;

  public get showCustomerCard(): boolean {
    return (
      this.paymentStore.customer &&
      this.paymentStore.customer.cards &&
      this.paymentStore.customer.cards.length &&
      this.paymentStore.verificationCustomer &&
      !this.isRemoveCard &&
      this.isFormLoaded &&
      (this.showCardPaymentForm || this.isSourcePayment)
    );
  }

  public get showPaymentForm(): boolean {
    return (!this.paymentStore.verificationCustomer ||
      this.cardId === NO_SELECTED_CARD ||
      !this.isFormLoaded || this.showGiftCardForm) && !this.isSendPayRequest;
  }

  public get showCardForm(): boolean {
    return this.showCardPaymentForm;
  }

  public get showGiftCardForm(): boolean {
    return this.showGiftCardPaymentForm && !this.isTabOrderCreating && this.paymentStore.fulfilmentType !== FulfillmentType.DELIVERY && !this.sharedOrderId;
  }

  public get showBillingAddress(): boolean {
    return this.isLoaded && !this.isSendPayRequest && this.isBillingAddressRequired;
  }

  public get isMobile(): boolean {
    return this.platform.is('mobile') || this.platform.width() < 600;
  }

  public get isValidEmail(): boolean {
    return EMAIL_PATTERN.test(String(this.paymentStore.email || this.email).toLowerCase());
  }

  public get isValidCustomerSavedEmail(): boolean {
    if (!this.paymentStore.customer || !this.paymentStore.customer.emailAddress) {
      return false;
    }
    return EMAIL_PATTERN.test(String(this.paymentStore.customer.emailAddress).toLowerCase());
  }

  public get isTabOrderCreating(): boolean {
    return this.paymentStore.fulfilmentType === FulfillmentType.TABLESIDE && this.restaurant.isTabsEnabled &&
      (this.paymentStore.createTabChecked || !this.tabOptionSelected);
  }

  public get hideSaveCard(): boolean {
    return this.paymentStore.createTabChecked || this.showGiftCardForm || this.isSubscription;
  }

  public get hideCustomerInfoField(): boolean {
    return !this.isLoaded || this.isSendPayRequest;
  }

  public get saveCardCheckboxDisabled(): boolean {
    return (Object.keys(this.cartStore.orderMap).length > 1 || this.paymentStore.createTabChecked) && !this.isGroup;
  }

  public get isGivenNameInvalid(): boolean {
    return !this.givenName || this.paymentStore.givenName === 'Kyoo' || this.paymentStore.givenName === 'Kyoo Customer';
  }

  public get isFamilyNameInvalid(): boolean {
    return !this.familyName || this.paymentStore.familyName === 'Customer';
  }

  public get isNameKyooCustomer(): boolean {
    return this.paymentStore.givenName === 'Kyoo' || this.paymentStore.familyName === 'Customer' || this.paymentStore.givenName === 'Kyoo Customer';
  }

  public get isDisabledWalletButtons(): boolean {
    return (
      !this.paymentStore.customer ||
      this._invalid ||
      this.isLoading ||
      this.paymentStore.isWaitingUpdate ||
      (this.isCustomerHaveCards && (this.isGivenNameInvalid || this.isFamilyNameInvalid)) ||
      this.isGivenNameInvalid ||
      this.isFamilyNameInvalid
    );
  }

  public get isCustomerHaveCards(): boolean {
    if (this.paymentStore.customer) {
      return !!this.paymentStore.customer.cards;
    } else {
      return false;
    }
  }

  public get isSavedCustomerWrongName(): boolean {
    if (!this.isNeedCustomerName) {
      if (this.isNameKyooCustomer) {
        this.isNeedCustomerName = true;
      }
    }
    return this.isNeedCustomerName;
  }

  public get isSavedCustomerWrongEmail(): boolean {
    return this.isEmailRequired && !this.isValidCustomerSavedEmail;
  }

  public get isSavedCustomerWrongAddress(): boolean {
    const emailRequired = this.isBillingAddressRequired;
    if (!this.isNeedBillingAddress && emailRequired) {
      if (!this.paymentStore.billingAddress) {
        this.isNeedBillingAddress = true;
      }
    }
    return this.isNeedBillingAddress;
  }

  public get showWallets(): boolean {
    if ((!this.group && !this.restaurant) || this.isGroup || this.isSubscription) {
      return false;
    }
    if (!this.restaurant) {
      return false;
    }
    return !this.isTabOrderCreating && this.restaurant.enableAppleGooglePay;
  }

  public get isBrowserSafari(): boolean {
    const chromeAgent = navigator.userAgent.indexOf('Chrome') > -1 || navigator.userAgent.indexOf('CriOS') > -1;
    let safariAgent = navigator.userAgent.indexOf('Safari') > -1;
    if (chromeAgent && safariAgent) safariAgent = false;
    return safariAgent;
  }

  public get allowCreateGiftCard(): boolean {
    if ((!this.restaurant && !this.restaurants) || this.isSubscription) {
      return false;
    }
    return this.isGroup ? false : this.restaurant?.enableGiftCards;
  }

  public get allowUseGiftCard(): boolean {
    if (this.sharedOrderId) {
      return false;
    }
    if ((!this.restaurant && !this.restaurants) || this.isSubscription) { return false; }
    return (this.isGroup ? false : this.restaurant?.enableGiftCards) &&
      !this.isTabOrderCreating && this.paymentStore.fulfilmentType !== FulfillmentType.DELIVERY;
  }

  public get isEmailRequired(): boolean {
    if (!this.restaurant && !this.restaurants) { return false; }
    if (this.isSubscription) { return true; }
    return this.isGroup ? !!this.restaurants && !!this.restaurants.find((restaurant) =>
      restaurant.requireEmail === true) : this.restaurant.requireEmail;
  }

  public get isBillingAddressRequired(): boolean {
    if (!this.restaurant && !this.restaurants) { return false; }
    return this.isGroup ? !!this.restaurants?.find((restaurant) =>
      restaurant.requireBillingAddress === true) : this.restaurant.requireBillingAddress;
  }

  public get isSharedCardsEnabled(): boolean {
    if (!this.restaurant && !this.restaurants) {
      return false;
    }
    return this.isGroup ? false : this.restaurant.isSharedCardsEnabled;
  }

  public get isGoogleApplePayEnabled(): boolean {
    if (!this.restaurant && !this.restaurants) {
      return false;
    }
    return this.isGroup ? false : this.restaurant.enableAppleGooglePay;
  }

  public get isDeliverySelected(): boolean {
    return this.paymentStore.fulfilmentType && this.paymentStore.fulfilmentType === FulfillmentType.DELIVERY;
  }

  public get total(): number {
    const tips = this.paymentStore.createTabChecked ? 0 : this.cartStore.tips;
    return this.cartStore.totalPrice + this.cartStore.totalTaxesPrice + this.deliveryCost() + tips;
  }

  public get isGroup(): boolean {
    return this.restaurantStore.isGroup;
  }
  public get showSavedCardForSource(): boolean {
    return this.showCustomerCard && this.isSourcePayment;
  }
  private deliveryCost(): number {
    return this.isDeliverySelected ? (this.cartStore.deliveryFee / 100.0) : 0;
  }

  constructor(
    public paymentStore: PaymentStore,
    public platform: Platform,
    private restaurantStore: RestaurantStore,
    private orderApiService: OrderApiService,
    private paymentService: PaymentService,
    private cartStore: CartStore,
    private router: Router,
    private routeService: RouteService,
    private routing: ActivatedRoute,
    private storageService: StorageService,
    private formatDataService: FormatDataService,
    private formatStyleService: FormatStyleService,
    private cdRef: ChangeDetectorRef,
    private giftCardService: GiftCardService,
    private sharedOrderService: SharedOrderService,
    private squarePayService: SquarePayService
  ) {
    this.mode = localStorage.getItem('mode');
    this.restaurantStore.restaurantAvailableStatus$.subscribe((data: RestaurantAvailableStatus) => {
      if (data) {
        this.isGiftCardPermission = data.gift_cards_permissions_requested;
      }
    });
    this.restaurantStore.restaurants$.subscribe((restaurant: Restaurant[]) => {
      this.merchantId = restaurant[0].merchantId;
    });
    this.paymentService.getPartialBalance.subscribe((balance: PartialBalance) => {
      this.remainBalance = balance.card;
      this.giftCardBalance = (balance.giftCard).toFixed(2);
      this.sourcePayment(balance);
    });
  }

  public ngOnInit(): void {
    this.initComponent();
    this.initListeners();
    this.sharedOrderId = this.sharedOrderService.sharedOrderId$;
  }

  public ngOnChanges({ forceTouched, checkoutInvalid }: SimpleChanges): void {
    this.onForceTouchedChange(forceTouched);
  }

  public ngOnDestroy(): void {
    this.hideGiftCardAndShowPaymentForm();
    this.destroyed$.next();
  }

  public ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  public showSaveCardCheckboxMessage(): void {
    this.showCheckboxWarningMessage = true;
  }

  public hideSaveCardCheckboxMessage(): void {
    this.showCheckboxWarningMessage = false;
  }

  public swapPaymentMethod(): void {
    this.isSourcePayment = false;
    if (this.isLoading) { return; }
    if (this.showGiftCardPaymentForm && this.showCardPaymentForm) {
      this.showGiftCardPaymentForm = false;
      this.isAdditional = false;
      this.isGiftBalance = false;
      this.isGiftCardVerify = false;
      this.giftCardService.setGiftCard(new GiftCard());
      return;
    }
    this.showCardPaymentForm = !this.showCardPaymentForm;
    this.showGiftCardPaymentForm = !this.showGiftCardPaymentForm;
    if (!this.showGiftCardPaymentForm && this.allowUseGiftCard) {
      this.giftCardService.setGiftCard(new GiftCard());
      this.isGiftBalance = false;
      this.isAdditional = false;
      this.isGiftCardVerify = false;
    }
  }

  public showMobileSaveCardCheckboxMessage(): void {
    if (this.isMobile && this.saveCardCheckboxDisabled) {
      this.showSaveCardCheckboxMessage();
      setTimeout(() => this.hideSaveCardCheckboxMessage(), 3000);
    }
  }

  private onForceTouchedChange(forceTouched: SimpleChange): void {
    if (!forceTouched) {
      return;
    }
    const { previousValue: previousForceTouched, currentValue: currentForceTouched } = forceTouched;
    if (previousForceTouched !== currentForceTouched && currentForceTouched) {
      this.handleValidate();
    }
  }

  private handleValidate(): void {
    this.touched = true;
    const valid = !!(this.givenName || this.familyName);
    if (valid !== this.valid) {
      this.validChange.emit(valid);
    }
    this.valid = valid;
  }

  private initComponent(): void {
    this.lastTotal = this.total;
    this.cardId = NO_SELECTED_CARD;
    this.initPaymentForm();
    if (this.isKioskForm()) {
      this.startTimer();
    }
  }

  private async initPaymentForm(): Promise<void> {
    try {
      const locationId = Object.keys(ConvertItemsService.fromCartItemsToShopLineItems(this.cartStore.items))[0];
      // @ts-ignore
      this.paymentForm = Square.payments(this.restaurantStore.restaurantCountryInfo.applicationId, locationId);
      this.card = await this.paymentForm.card({
        includeInputLabels: true,
        style: {
          '.input-container.is-focus': {
            borderColor: this.formatStyleService.getBrandColor(this.isGroup, this.group, this.restaurant),
          },
        },
      });
      await this.card.attach('#card');
      if (this.allowCreateGiftCard) {
        await this.initGiftCard();
      }
      await this.initWalletForm();
      this.isLoaded = true;
      this.isFormLoaded = true;
      this.hideGiftCardAndShowPaymentForm();
    } catch (err) {
      return err;
    }
  }

  private async initGiftCard(): Promise<any> {
    try {
      this.giftCard = await this.paymentForm.giftCard({
        includeInputLabels: true,
        style: {
          '.input-container.is-focus': {
            borderColor: this.formatStyleService.getBrandColor(this.isGroup, this.group, this.restaurant),
          },
        },
      });
      await this.giftCard.attach('#gift-card');
      this.isLoaded = true;
    } catch (err) {
      return err;
    }
  }

  private async initGooglePay(): Promise<any> {
    try {
      this.googlePay = await this.paymentForm.googlePay(this.getWalletPaymentRequest());
      if(!this.isGoogleAttached){
        await this.googlePay.attach('#googlePay', {
          buttonSizeMode: 'fill',
          buttonType: 'long',
        });
        this.isGoogleAttached = true;
      }
    } catch (err) {
      return err;
    }
  }

  private async nativeApplePay():Promise<any> {
    let result = new SquareTokenize()
    try{
      let response = await this.squarePayService.nativeApplePay(this.getWalletPaymentRequest());
      if(response == SquareStatus.cancel){
        result.status = SquareStatus.cancel;
      } else {
        result.status = SquareStatus.ok
        result.token = response
      }
      return result
    } catch(err){
      throw new MobilePayError(err)
    }
  }

  private async nativeGooglePay():Promise<any> {
    const locationId = Object.keys(ConvertItemsService.fromCartItemsToShopLineItems(this.cartStore.items))[0];
    let result = new SquareTokenize()
    if(locationId == null){
      throw new MobilePayError("locationId was null");
    }
    try{
      let response = await this.squarePayService.nativeGooglePay(this.getWalletPaymentRequest(),locationId);
      if(response == SquareStatus.cancel){
        result.status = SquareStatus.cancel;
      } else {
        result.status = SquareStatus.ok
        result.token = response
      }
      return result
    } catch(err){
      throw new MobilePayError(err)
    }


  }

  private async initApplePay(): Promise<any> {
    try {
      this.applePay = await this.paymentForm.applePay(this.getWalletPaymentRequest());
    } catch (err) {
      return err;
    }
  }

  private async initWalletForm(): Promise<any> {
    if (this.isGoogleApplePayEnabled) {
      await this.initGooglePay();
      if (this.isBrowserSafari) {
        await this.initApplePay();
      }
    }
  }

  private async reInitWalletForm(): Promise<void> {
    if (
      (this.paymentStore.statePayment === StatePayment.INIT ||
        this.paymentStore.statePayment === StatePayment.FAILED ||
        this.paymentStore.statePayment === StatePayment.TIMEOVER) &&
      this.lastTotal !== this.total
    ) {
      this.lastTotal = this.total;
      if (this.applePay != null) {
        await this.applePay.destroy();
      }
      if (this.googlePay != null) {
            await this.initWalletForm();
      }
    }
  }

  private async reInitWalletFormPartial(): Promise<void> {
    if (this.applePay != null) {
      await this.applePay.destroy();
    }
    if (this.googlePay != null) {
      await this.initWalletForm();
      this.walletFormDestroyed = false;
    }
  }

  private getWalletPaymentRequest(): any {
    return this.paymentForm.paymentRequest({
      countryCode: 'US',
      currencyCode: 'USD',
      total: {
        amount: String(this.formatDataService.getFormattedPrice(this.isSourcePayment ? this.remainBalance : this.total)),
        label: 'Total',
        pending: false,
      },
    });
  }

  private initListeners(): void {
    this.paymentStore.verificationCustomer$.pipe(takeUntil(this.destroyed$)).subscribe((isVerificate: boolean) => {
      if (this.paymentStore.givenName === null && this.paymentStore.familyName === null) {
        this.givenName = '';
        this.familyName = '';
      }
      if (this.paymentStore.email) {
        this.email = this.paymentStore.email;
      }
      if (this.paymentStore.givenName) {
        this.givenName = this.paymentStore.givenName;
      }
      if (this.paymentStore.familyName) {
        this.familyName = this.paymentStore.familyName;
      }
      if (!isVerificate) {
        return;
      }
      const customer = this.paymentStore.customer;
      if (customer && customer.givenName && customer.familyName) {
        this.givenName = customer.givenName;
        this.familyName = customer.familyName;
        this.changeGivenName();
        this.changeFamilyName();
      }
      if (customer && customer.emailAddress) {
        this.email = customer.emailAddress;
        this.changeEmail();
      }
      this.loadCustomerCard();
    });

    this.paymentStore.statePayment$.pipe(takeUntil(this.destroyed$)).subscribe((state: StatePayment) => {
      if (state === StatePayment.SEND) {
        this.submitPayment(this.paymentStore.customer);
      } else if (state === StatePayment.SUCCESS) {
        if (this.savedPayment && this.paymentStore.customer != null) {
          let customerData: object = {
            token: this.token,
            phone: this.paymentStore.customer.phone,
            orderBotUserId: this.paymentStore.customer.orderBotUserId,
          };
          this.storageService.set(STORAGE_CUSTOMER_DATA, customerData);
        }
      } else if (state === StatePayment.FAILED || state === StatePayment.TIMEOVER) {
        if (!this.paymentStore.customer?.cards || this.paymentStore.customer?.cards?.length === 0) {
          this.useSavedPayment(false);
        }
      }
    });

    this.paymentStore.fulfilmentType$.pipe(takeUntil(this.destroyed$)).subscribe((fulfillment: FulfillmentType) => {
      if (fulfillment === FulfillmentType.DELIVERY) {
        this.hideGiftCardAndShowPaymentForm();
      }
    });

    this.paymentStore.createTabChecked$.pipe(takeUntil(this.destroyed$)).subscribe((checked: boolean) => {
      if (checked) {
        this.hideGiftCardAndShowPaymentForm();
      }
    });
    if (this.isGoogleApplePayEnabled) {
      this.cartStore.items$.pipe(takeUntil(this.destroyed$)).subscribe(async () => {
        if(this.isSourcePayment){
          this.reInitWallet = true;
        } else {
          this.reInitWalletForm();
        }
      });
      this.cartStore.tip$.pipe(takeUntil(this.destroyed$)).subscribe(async () => {
        if(this.isSourcePayment){
          this.reInitWallet = true;
        } else {
          this.reInitWalletForm();
        }
      });
    }
  }

  public async walletPayment(nonce: NonceType): Promise<void> {
    this.startWalletProcess();
    if (!this.paymentStore.customer.familyName || !this.paymentStore.customer.givenName) {
      this.paymentStore.customer.givenName = this.paymentStore.givenName;
      this.paymentStore.customer.familyName = this.paymentStore.familyName;
    }
    this.onWalletForceTouched.emit();
    await this.getNonce(nonce);
  }

  public changeForceTouched(): void {
    if (this.isDisabledWalletButtons) {
      this.onWalletForceTouched.emit();
    }
  }

  public loadCustomerCard() {
    if (!this.paymentStore.customer) {
      return;
    }
    this.isHaveCard = this.paymentStore.customer.cards && this.paymentStore.customer.cards.length;
    if (this.isHaveCard) {
      this.cardId = this.paymentStore.customer.cards[0].id;
      this.squareTokenizeCard.token = this.cardId;
    } else {
      this.cardId = NO_SELECTED_CARD;
    }
  }

  public changeGivenName() {
    this.paymentStore.setGivenName(this.givenName);
  }

  public changeFamilyName() {
    this.paymentStore.setFamilyName(this.familyName);
  }

  public changeEmail() {
    this.paymentStore.setEmail(this.email);
  }

  public useSavedPayment(checked: boolean): void {
    const savedPaymentState = this.paymentService.getSavedPaymentState(checked);
    this.savedPayment = savedPaymentState.isSavedPayment;
    this.touched = savedPaymentState.touched;
    this.cardId = savedPaymentState.cardId;
  }

  public getCardId(cardId: string): void {
    this.cardId = cardId;
  }

  public getIsRemoveCard(isRemoveCard: boolean): void {
    if (isRemoveCard && !this.paymentForm) {
      this.initPaymentForm();
    }
  }

  public getSavedPayment(savedPayment: boolean): void {
    this.savedPayment = savedPayment;
  }
  public getTouched(touched: boolean): void {
    this.touched = touched;
  }
  public async sendCardData(): Promise<void> {
    this.isLoaded = true;
    if (this.showCustomerCard && this.isSourcePayment && (this.savedPayment || this.paymentStore.isWalletPayment)) {
      await this.paymentWithSource();
    } else if(this.isSourcePayment && this.paymentStore.isWalletPayment) {
      await this.paymentWithSource();
    } else if (this.isSourcePayment) {
      await this.getNonce(NonceType.REGULAR);
    } else if (this.showGiftCardForm) {
      await this.getNonce(NonceType.GIFT_CARD);
    } else {
      if (this.isSubscription) {
        await this.subscribe();
      } else {
        if (this.showPaymentForm && !this.paymentStore.isWalletPayment) {
          await this.getNonce(NonceType.REGULAR);
        } else {
          this.payWithCard(this.isGroup);
        }
      }
    }
  }

  public submitPayment(customer): void {
    if (!customer) {
      return;
    }
    if (this.savedPayment) {
      this.cardId = customer.cards ? this.cardId : NO_SELECTED_CARD;
    } else {
      this.cardId = NO_SELECTED_CARD;
    }
    if (this.isGroup || (this.restaurantStore.group && this.paymentStore.createTabChecked)) {
      if (!this.isGroup) {
        this.restaurantStore.isGroup = true;
        this.group = this.restaurantStore.group;
        this.restaurants = [this.restaurant];
      }
      if (this.groupOrderId) {
        this.sendCardData();
      } else {
        this.submitGroupOrder(this.group.groupId);
      }
      return;
    }
    const locationIds = Object.keys(this.cartStore.orderMap);
    for (const locationId of locationIds) {
      const locationOrder = this.cartStore.orderMap[locationId];
      this.payLocationId = locationId;
      if (!locationOrder.isPaid) {
        if (locationOrder.isSubmitted && !locationOrder.isUpdated) {
          this.sendCardData();
        } else {
          this.updateAndSubmitSingleOrder(locationId);
        }
      }
    }
  }

  public updateAndSubmitSingleOrder(locationId: string): void {
    const orderMap = this.cartStore.orderMap[locationId];
    const order = this.orderApiService.getOrderWithTipMoney(locationId);

    if (order.is_tab_order || this.cartStore.tab) {
      this.submitTab(locationId, orderMap.id, orderMap.order);
    } else {
      this.submitOrder(locationId, orderMap.id, order);
    }
  }

  private submitOrder(locationId: string, orderId: string, order: Order): void {
    if (this.sharedOrderService.sharedOwnerId$) {
      order.is_shared_order = true;
      order.shared_order_id = this.sharedOrderService.sharedOwnerId$;
      order.single_order_ids = this.sharedOrderService.singleOrderIds;
    }
    if (!this.isProcessingOrder) {
      this.isProcessingOrder = true;
      this.orderApiService.updateAndSubmitOrder(locationId, order, orderId).subscribe(
        (transactionInfo: any) => {
          const hasPayment = transactionInfo.amount_in_cents > 0 || transactionInfo.auto_gratuity_cents > 0;
          this.cartStore.orderMap[locationId].isSubmitted = true;
          this.cartStore.orderMap[locationId].isUpdated = false;
          if (hasPayment) {
            this.paymentStore.transactionId = transactionInfo.transaction_id;
            this.sendCardData();
          } else {
            const isSuccess = transactionInfo.kyoo_transaction && transactionInfo.kyoo_transaction.datetime_authorized;
            if (isSuccess) {
              this.paymentStore.setStatePayment(StatePayment.SUCCESS);
            }
          }
        },
        (error: HttpErrorResponse) => {
          this.payErrorCallBack(error);
        }
      );
    } else {
      this.processOrderQueue.push({ locationId, orderId, order });
    }
  }

  private submitTab(locationId: string, orderId: string, order: Order) {
    if (!this.isProcessingOrder) {
      this.isProcessingOrder = true;
      if (!this.cartStore.tab) {
        this.orderApiService.submitTab(locationId, order).subscribe(
          (tab: OrderTab) => {
            this.cartStore.orderMap[locationId].isSubmitted = true;
            this.cartStore.orderMap[locationId].isUpdated = false;
            this.paymentStore.transactionId = tab.transaction_id;
            this.cartStore.tab = tab;
            this.sendCardData();
          },
          (error) => this.payErrorCallBack(error)
        );
      } else {
        this.updateTab(locationId, orderId, this.cartStore.tab.tab_id);
      }
    } else {
      this.processOrderQueue.push({ locationId, orderId, order });
    }
  }

  private updateTab(locationId: string, orderId: string, tabId: string) {
    this.orderApiService.updateTab(locationId, orderId, tabId).subscribe(
      (tab: OrderTab) => {
        this.cartStore.tab = tab;
        this.submitNextOrder();
      },
      (error: HttpErrorResponse) => {
        this.payErrorCallBack(error);
      }
    );
  }

  private submitNextOrder() {
    this.isProcessingOrder = false;
    if (this.processOrderQueue.length !== 0) {
      const { locationId, orderId, order } = this.processOrderQueue.shift();
      if (order.is_tab_order || this.cartStore.tab) {
        this.updateTab(locationId, orderId, this.cartStore.tab.tab_id);
      } else {
        this.submitOrder(locationId, orderId, order);
      }
    } else {
      this.paymentStore.savedCardId = null;
      this.paymentStore.setStatePayment(StatePayment.SUCCESS);
    }
  }

  private submitGroupOrder(groupId: string): void {
    this.isProcessingOrder = true;
    const groupOrder = this.orderApiService.createGroupOrder(this.restaurants);
    const customOrderNumber = sessionStorage.getItem(UrlParam.customInstruction);
    if (customOrderNumber) {
      groupOrder.custom_number = customOrderNumber;
    }
    this.orderApiService.submitGroupOrder(groupId, groupOrder).subscribe(
      (groupOrderInfo: any) => {
        this.groupOrderId = groupOrderInfo.id || groupOrderInfo.group_order_id;
        if (groupOrder.is_tab_order) {
          this.cartStore.groupTab = groupOrderInfo;
        }
        this.sendCardData();
      },
      (error: HttpErrorResponse) => {
        this.payErrorCallBack(error);
      }
    );
  }

  public async getNonce(nonceType: NonceType): Promise<void> {
    this.isSendPayRequest = true;
    let result: SquareTokenize;
    try {
      if (this.isSourcePayment && !this.paymentStore.isWalletPayment && nonceType != NonceType.GIFT_CARD) {
        result = await this.card.tokenize();
        this.squareTokenizeCard = result;
      } else if (nonceType === NonceType.GOOGLE_PAY) {
        result = await this.googlePay.tokenize();
      } else if (nonceType === NonceType.APPLE_PAY) {
        result = await this.applePay.tokenize();
      } else if (nonceType === NonceType.APPLE_PAY_NATIVE) {
        result = await this.nativeApplePay();
      }
      else if (nonceType === NonceType.GOOGLE_PAY_NATIVE) {
        result = await this.nativeGooglePay();
      }
      else if (nonceType === NonceType.GIFT_CARD) {
        await this.verifyGiftCard();
        result = this.squareTokenizeGift;
      } else {
        result = await this.card.tokenize();
      }
    } catch (error) {
      if(NonceType.APPLE_PAY_NATIVE || NonceType.GOOGLE_PAY_NATIVE) {
        this.payErrorCallBack(error);
      } else {
        this.payErrorCallBack(error, PaymentError.invalid_card_data);
      }
      return;
    }
    if (result.status === SquareStatus.ok) {
      this.cardId = result.token;
      if (nonceType === NonceType.SUBSCRIPTION) {
        this.saveCard();
      } else if (nonceType === NonceType.APPLE_PAY || nonceType === NonceType.GOOGLE_PAY || nonceType === NonceType.APPLE_PAY_NATIVE || nonceType === NonceType.GOOGLE_PAY_NATIVE) {
        this.squareTokenizeCard.token = this.cardId
        this.walletPay();
      } else if (nonceType === NonceType.GIFT_CARD) {
        if (this.doSaveGiftCard && this.isGiftCardPermission) {
          this.saveCard(true);
        } else {
          await this.processOrderWithNonce(true);
        }
      } else {
        if (this.doSaveCard && !this.paymentStore.isWalletPayment) {
          this.saveCard();
        } else {
          await this.processOrderWithNonce(false);
        }
      }
    } else if (result.status === SquareStatus.cancel) {
      this.stopProcessOrder();
    } else {
      this.payErrorCallBack(null, PaymentError.invalid_card_data);
    }
  }

  public async verifyGiftCard(): Promise<void> {
    this.showErrorMessageAndAllowPayRetry(null);
    this.isSpinner = true;
    try {
      this.squareTokenizeGift = await this.giftCard.tokenize();
      if (this.squareTokenizeGift.status === SquareStatus.ok && this.isGiftCardPermission) {
        this.checkGiftCardResult();
        return;
      }
      this.isSpinner = false;
    } catch (e) {
      this.isSpinner = false;
      this.payErrorCallBack(e, GiftCardError.invalid);
    }
  }

  public editGiftCard(): void {
    this.isGiftCardVerify = false;
    this.isGiftBalance = false;
    this.isAdditional = false;
    this.showCardPaymentForm = false;
    this.giftCardService.setGiftCard(new GiftCard());
  }

  private saveCard(isGift: boolean = false): void {
    if (this.isSubscription) {
      this.paymentService
        .saveCardForSubscription(
          this.cardId,
          this.paymentStore.createSubscriptionData.subscription_id,
          this.paymentStore.givenName,
          this.paymentStore.familyName
        )
        .subscribe(
          (cardData: { card_id }) => {
            this.saveCardId(cardData.card_id);
            this.paymentStore.createSubscriptionData.card_id = cardData.card_id;
            this.processOrderWithNonce(false);
          },
          (error: HttpErrorResponse) => {
            this.saveCardError(error);
          }
        );
    } else if (this.isGroup) {
      this.paymentService.groupSaveCard(this.cardId, this.groupOrderId, this.paymentStore.givenName, this.paymentStore.familyName).subscribe(
        (cardData: { card_id }) => {
          this.saveCardId(cardData.card_id);
          this.payWithCard(this.isGroup);
        },
        (error: HttpErrorResponse) => {
          this.saveCardError(error);
        }
      );
    } else {
        const token = isGift ? this.squareTokenizeGift.token : this.cardId
        this.paymentService.saveCard(token, this.paymentStore.transactionId, this.paymentStore.givenName, this.paymentStore.familyName, isGift).subscribe(
          (cardData: { card_id }) => {
            this.saveCardId(cardData.card_id);
            if (isGift) {
              this.cardId = cardData.card_id;
              if(this.isSourcePayment){
                this.processOrderWithNonce(isGift)
                return;
              }
              this.processOrder(isGift);
              return;
            }
            if(this.isSourcePayment){
              this.paymentWithSource();
            } else {
              this.payWithCard(this.isGroup);
            }
          },
          (error: HttpErrorResponse) => {
            this.saveCardError(error);
          }
        );
    }
  }

  private checkGiftCardResult() {
    this.giftCardService.getGiftCardFromNonce(new GiftCarFromNonce(
      this.merchantId,
      this.squareTokenizeGift.token
    )).subscribe((giftCard: GiftCard) => {
      this.validateGiftCardStatus(giftCard);
      if (giftCard.balance === 0 && giftCard.state === GiftCardStatus.active) {
        this.showErrorMessageAndAllowPayRetry(GiftCardError.zeroBalance);
        this.isGiftCardVerify = false;
        this.isSpinner = false;
        return;
      }
      this.reInitWallet = true;
      this.isSpinner = false;
    }, (error) => {
      this.isSpinner = !this.isSpinner;
      this.isGiftCardVerify = false;
      this.payErrorCallBack(error);
    });
  }

  private validateGiftCardStatus(giftCard: GiftCard): any {
    switch (giftCard.state) {
      case GiftCardStatus.active:
        return this.isGiftCardVerify = true;
      case GiftCardStatus.blocked:
        return this.showErrorMessageAndAllowPayRetry(GiftCardError.blocked);
      case GiftCardStatus.deactivated:
        return this.showErrorMessageAndAllowPayRetry(GiftCardError.deactivated);
      case GiftCardStatus.pending:
        return this.showErrorMessageAndAllowPayRetry(GiftCardError.pending);
      default: return;
    }
  }

  private walletPay(): void {
    const locationIds = Object.keys(this.cartStore.orderMap);
    for (const locationId of locationIds) {
      const locationOrder = this.cartStore.orderMap[locationId];
      this.payLocationId = locationId;
      if (!locationOrder.isPaid) {
        this.updateAndSubmitSingleOrder(locationId);
      }
    }
  }

  private async subscribe(): Promise<void> {
    const order = this.orderApiService.getOrderWithTipMoney(this.paymentStore.createSubscriptionData.location_id);
    this.paymentStore.createSubscriptionData.card_id = this.cardId;
    this.paymentStore.createSubscriptionData.order_request = order;
    this.orderApiService.createSubscription(this.paymentStore.createSubscriptionData).subscribe(
      (result) => {
        this.paymentStore.createSubscriptionData.subscription_id = result.id;
        if (this.showPaymentForm) {
          this.getNonce(NonceType.SUBSCRIPTION);
        } else {
          this.processOrderWithNonce(false);
        }
      },
      (error: HttpErrorResponse) => {
        this.payErrorCallBack(error);
      }
    );
  }

  private async processOrderWithNonce(isGiftCard: boolean): Promise<void> {
    if (this.isSubscription) {
      this.paymentService.processSubscription(this.paymentStore.createSubscriptionData).subscribe(
        (result) => {
          this.paymentStore.savedCardId = null;
          this.paymentStore.setStatePayment(StatePayment.SUBSCRIBED);
        },
        (error: HttpErrorResponse) => {
          this.payErrorCallBack(error);
        }
      );
    } else if (this.isGroup) {
      this.paymentService.groupProcessOrder(this.cardId, this.groupOrderId, this.paymentStore.givenName, this.paymentStore.familyName).subscribe(
        (data) => {
          this.paySuccessCallBack(data);
        },
        (error: HttpErrorResponse) => {
          this.processOrderError(error);
        }
      );
    } else {
      if (this.isSourcePayment) {
        await this.paymentWithSource();
        return;
      } else if (this.paymentStore.transactionId) {
       this.processOrder(isGiftCard);
      }
    }
  }

  private processOrder(isGiftCard: boolean): void {
    const token = isGiftCard ? this.squareTokenizeGift.token : this.cardId;
    this.paymentService.processOrder(token, this.paymentStore.transactionId, isGiftCard)
      .subscribe((data) => {
          this.paySuccessCallBack(data);
        }, (error: HttpErrorResponse) => {
          if (error.status === StatusCode.payment_required) {
            this.payErrorCallBack(error);
            this.isAdditional = true;
            this.showCardPaymentForm = true;
            this.showGiftCardPaymentForm = true;
            this.isSourcePayment = true;
            return;
          }
          this.processOrderError(error);
        }
      );
  }

  private payWithCard(isGroup: boolean): void {
    if (isGroup) {
      this.paymentService.groupPayWithSavedCard(this.groupOrderId, this.cardId).subscribe(
        (data) => {
          this.paySuccessCallBack(data);
        },
        (error: HttpErrorResponse) => {
          this.payErrorCallBack(error);
        }
      );
    } else {
      this.paymentService.payWithSavedCard(this.paymentStore.transactionId, this.cardId).subscribe(
        (data) => {
          this.paySuccessCallBack(data);
        },
        (error: HttpErrorResponse) => {
          this.payErrorCallBack(error);
        }
      );
    }
  }

  public goToLastItemsPage(): void {
    const baseURl = this.routeService.getBaseUrl();
    const lastRestaurantId = localStorage.getItem('lastRestaurantId');

    this.router.navigate([baseURl, 'locations', lastRestaurantId], { queryParams: { fromPayment: true } }).catch((error) => console.error(error));
  }

  public checkMode(): boolean {
    return this.mode === Mode.mobile;
  }

  public isKioskForm(): boolean {
    return this.checkMode() && !this.isHaveCard;
  }

  private saveCardId(cardId: string): void {
    this.paymentStore.savedCardId = cardId;
    this.cardId = cardId;
  }

  private paySuccessCallBack(data: any): void {
    this.isSendPayRequest = false;
    if (this.paymentStore.isWalletPayment) {
      this.paymentStore.savedCardId = null;
      this.paymentStore.setStatePayment(StatePayment.SUCCESS);
      return;
    }
    if (!this.isGroup) {
      const locationOrder = this.cartStore.orderMap[this.payLocationId];
      locationOrder.isPaid = true;
    }
    if (this.paymentStore.savedCardId && !this.paymentStore.isWalletPayment) {
      this.useSavedPayment(true);
    }
    if (this.cartStore.tab) {
      const { location_id, transaction_order_id, tab_id } = this.cartStore.tab;
      this.updateTab(location_id, transaction_order_id, tab_id);
    } else if (this.cartStore.groupTab) {
      this.paymentStore.savedCardId = null;
      this.paymentStore.setStatePayment(StatePayment.SUCCESS);
    } else {
      this.submitNextOrder();
    }
  }

  private payErrorCallBack(error: any, message?: string): void {
    this.stopProcessOrder();
    if (error && error.name != null && error.name === 'TimeoutError') {
      this.paymentStore.setStatePayment(StatePayment.TIMEOVER);
    } else if (error && error.error && error.error.message) {
      this.paymentStore.setStatePayment(StatePayment.FAILED);
      this.showErrorMessageAndAllowPayRetry(error.error.message);
    } else {
      this.paymentStore.setStatePayment(StatePayment.FAILED);
      this.showErrorMessageAndAllowPayRetry(message ?? error.error.message);
    }
  }

  private payWithWalletErrorCallback(error: HttpErrorResponse): void {
    this.paymentStore.setStatePayment(StatePayment.FAILED);
  }

  private showErrorMessageAndAllowPayRetry(errorMessage): void {
    this.paymentItemError.emit(errorMessage);
    this.paymentStore.statePayment$.pipe(takeUntil(this.destroyed$)).subscribe((state: StatePayment) => {
      if (state !== StatePayment.SEND) {
        if (this.paymentStore.savedCardId && this.paymentStore.customer?.cards && this.paymentStore.customer?.cards?.length !== 0) {
          this.useSavedPayment(true);
        }
      }
    });
  }
  private async paymentWithSource(): Promise<void> {
    await this.verifyGiftCard();
    this.paymentService.paymentWithSeveralSources(this.paymentStore.transactionId, this.paymentSources())
      .subscribe(response => {
        this.paySuccessCallBack(response);
      }, error => {
        this.processOrderError(error);
      });
  }

  private saveCardError(error: HttpErrorResponse): void {
    this.payErrorCallBack(error, PaymentError.saving_card);
  }

  private processOrderError(error: HttpErrorResponse): void {
    this.payErrorCallBack(error, PaymentError.card_decline);
  }

  private startTimer() {
    timer(1000 * 60 * 15).subscribe(() => this.goToLastItemsPage());
  }

  private startWalletProcess(): void {
    this.paymentStore.setStatePayment(StatePayment.WALLET_PROCESS);
    this.paymentStore.isWalletPayment = true;
  }

  private stopProcessOrder(): void {
    if (this.cartStore.tab || this.cartStore.groupTab) {
      this.cartStore.tab = null;
      this.cartStore.groupTab = null;
    }
    this.isSendPayRequest = false;
    this.processOrderQueue = [];
    this.isProcessingOrder = false;
    this.paymentStore.setStatePayment(StatePayment.FAILED);
  }

  // private checkPlatform(): void {
  //   this.isCordova = this.platform.is('cordova');
  // }

  private hideGiftCardAndShowPaymentForm(): void {
    this.showCardPaymentForm = true;
    this.showGiftCardPaymentForm = false;
  }
  private sourcePayment(balance: PartialBalance): void {
    if (this.showGiftCardForm && this.isGiftCardVerify) {
      if (balance.card !== 0) {
        this.isGiftBalance = true;
        this.isAdditional = true;
        this.showCardPaymentForm = true;
        this.isSourcePayment = true;
        if(this.reInitWallet){
          this.reInitWalletFormPartial();
          this.reInitWallet=false;
        }
        return;
      }
      this.isGiftBalance = false;
      this.isAdditional = false;
      this.showCardPaymentForm = false;
      this.isSourcePayment = false;
    }
  }
  private paymentSources(): PaymentSources {
    const tender: PaymentTender[]  = [
      new PaymentTender(this.squareTokenizeGift.token, true),
      new PaymentTender(this.cardId == NO_SELECTED_CARD ? this.squareTokenizeCard.token : this.cardId, false),
    ];
    return new PaymentSources(tender);
  }
}
